<script>
    import { fade } from 'svelte/transition';
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Heading from '../components/Heading.svelte'
    import Button from '../components/LargeImgButton.svelte'
    import Slider from  '../widgets/Slider.svelte'
    const src = {
        pc:"img/service-fv.png",
        mb:"img/service-fv_mb.png"
    }
</script>
<svelte:head>
	<title>事業内容 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="hd-layout">
        <Centering>
            <Heading
                text={{
                    main:"SERVICE",
                    sub:"事業内容"
                }}
            />
        </Centering>
    </div>
    <div class="sv-hero">    
        <picture>   
            <source srcset="img/sv-1.png" media="(min-width: 641px)" />
            <source srcset="img/sv-1_mb.png" media="(min-width: 0px)" >
            <img src="img/sv-1.png" alt="">
        </picture>
        <div class="content-wrapper">
            <div class="content">
                <p>
                    株式会社有倉商店は納め専門の八百屋です。
                    市場・ＪＡ・農家の方々から新鮮で美味しい野菜・果物を仕入れることは、流通業として当たり前のことと考えます。
                    納先様の給食（料理や食べる方々）に合わせた食材を提供することが有倉商店の大切な仕事と考えます。
                    キャベツ一つとっても、料理により納品するサイズが異なってきます。ロールキャベツで使用する場合は、大きめのキャベツになりますし、バナナも保育園と病院では、サイズを変えての納品となります。お客様の現場でのニーズをお伺いして、きめ細やかな商品対応をすることにより、初めてお客様へのお役立ちが出来ると有倉商店は考えます。
                </p>
            </div>
        </div>
    </div>
    <div class="pic">
        <Centering>
            <div class="pic-wrapper">
                <div>
                    <h2>青果</h2>
                    <img src="img/ci_pic_kameido.png" alt="">
                </div>
                <div>
                    <h2>下処理野菜</h2>
                    <img src="img/ci_pic_yasai.png" alt="">
                </div>
            </div>
        </Centering>
    </div>
    <div class="slider">
        <Centering>
            <div class="slider-inner">
                <div class="hdr-layouts">
                    <span class="vr"></span><h2>有倉が取り組む強化5項目について</h2>
                </div>
                <Slider
                    data={[
                        {
                            num:"01",
                            title:"バナナ",
                            img:"img/slider1.png",
                            text:"バナナの熟成室を自社で管理。入荷時は「緑色」ですが、バナナ専門の社員が「お客様が食べる日時」に合わせて出荷時に最適な状態にしてお届けしています。また病院様に対しては、「エネ用」「無傷」等の特別な選別作業も行っております。"
                        },
                        {
                            num:"02",
                            title:"選果力",
                            img:"img/slider2.png",
                            text:"お客様の口に入る商品です。「虫」「汚れ」「傷み」が無いか、一つずつ手作業で商品を選果します。また、病院様のご要望により果物は「無傷」「エネ用」等々の対応を行っており、葉物野菜は、「葉先」玉葱は「ムキ玉」「芯取り」等々、お客様のご要望に合わせた商品を選果し、お役立ちをさせて頂いております。"
                        },
                        {
                            num:"03",
                            title:"仕入れ＆目利き",
                            img:"img/slider3.png",
                            text:"弊社を代表する仕入れのプロが、江戸・東京野菜を代表に毎日新鮮な野菜&果物を、豊洲市場、葛西市場、千葉市場、市川市場、その他各JA及び産地の農家から仕入れています。"
                        },
                        {
                            num:"04",
                            title:"提案",
                            img:"img/slider4.png",
                            text:"各産地のJA及び農家の方々及び仕入先のご協力で、有倉商店は小学校を中心に、食育の授業を開催させていただいています。有難いことに、年々授業の回数が増えてきており、課外授業として、芋ほりの体験も行っています。"
                        },
                        {
                            num:"05",
                            title:"フードロス削減",
                            img:"img/slider5.png",
                            text:"弊社が提供しております下処理野菜は、献立に使う必要な分だけを作成してお届けしている為、お客様の現場での廃棄ロスの削減及びお客様の作業負担削減のお手伝いをし、お役立ちをさせて頂いております。"
                        }
                    ]}
                />
            </div>
        </Centering>
    </div>
</div>


<style>
    .hd-layout{
        margin-top: 75px;
    }
    .sv-hero{
        display: flex;
        width:100%;
        min-width:1280px;
        height:540px;
        margin-top: 60px;
    }
    .sv-hero picture,.sv-hero img{
        width:100%;
        height:540px;
        object-fit: cover;
    }
    .sv-hero .content{
        display: flex;
        position: absolute;
        min-width: 528px;
        width:41%;
        height: 540px;
        background: #fff;
        opacity: 0.9;
        right:0;
    }
    .content-wrapper{
        position: absolute;
        height: 540px;
        width: 100%;
        margin: auto;
    }
    .content p{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        line-height: 36px;
        width: 409px;
        text-align: left;
        color: #000;
        margin-top: 56px;
        margin-left: 41px;
        margin-right: 78px;
        white-space: pre-line;
    }
    .pic{
        margin-top: 90px;
    }
    .pic-wrapper{
        width: 100%;
        display: flex;
        height: 355px;
        justify-content: space-between;
    }
    .pic h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 24px;
        text-align: left;
        color: #000;
    }
    .pic h2:after{
        content:"";
        display: block;
        height:3px;
        width:46px;
        background-color: #FF9B11;
        margin-top: 10px;
    }
    .slider{
        margin-top: 90px;
        display: flex;
        background-color: #fff;
        height:855px;
        margin-bottom: 125px;
    }
    .slider-inner{
        margin-top: 40px;
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .vr{
        width: 4px;
        height:35px;
        background-color: #FF9B11;
        margin-right: 25px;
        display: inline-block;
    }
    .slider h2{
        font-family: "Noto Sans JP",sans-serif;
        margin: 0;
        font-weight: normal;
        font-size: 24px;
        line-height: 35px;
        height: 35px;
        text-align: left;
        color: #000;
        width: 382px;
        background-color: #FF9B11;
        display: inline-block;
    }
    .hdr-layouts{
        display: flex;
        align-items: center;
    }
    @media screen and (max-width:640px){
        .sv-hero{
            min-width:100%;
            height:815px;
            width:100%;
        }
        .sv-hero picture,.sv-hero img{
            height:815px;
            width:100%;
            object-fit: cover;
        }
        .sv-hero .content{
        width:100%;
        min-width: auto;
        height: 568px;
        right:auto;
        bottom:0;
    }
    .hdr-layouts{
        margin-bottom: 30px;
    }
    .content-wrapper{
        height: 815px;
        width: 100%;
    }
    .content p{
        font-weight: normal;
        width: 90%;
        margin: auto;
    }
    .pic-wrapper{
        flex-direction: column;
        height:717px;
    }
    .pic img{
        width: 100%;
        object-fit: cover;
        height:279px;
    }
    .pic h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        font-size:16px;
    }
    .slider h2{
        font-size: 16px;
        line-height: 35px;
        height: 35px;
        width: 249px;
    }
    .slider{
        overflow-x: hidden;
        position: relative;
    }
    .slider-inner{
        position: relative;
    }
}
</style>
